import { render, staticRenderFns } from "./page-reports-actions-button.vue?vue&type=template&id=6b778d3c&"
import script from "./page-reports-actions-button.vue?vue&type=script&lang=js&"
export * from "./page-reports-actions-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports